import axios from '@/framework/router/axios'

const apiTenantAdd = async(postdata) => {
  return axios.post('/tenant', postdata)
}

const apiTenantEdit = async(putdata) => {
  return axios.put('/tenant', [putdata])
}

const apiTenantQuery = async(postdata, column, params) => {
  return axios.post('/tenant/query', { entity: postdata, orderItemList: [{
    asc: true,
    column
  }] }, {
    params
  })
}

export default {
  apiTenantAdd,
  apiTenantEdit,
  apiTenantQuery
}
